module.exports = __webpack_public_path__ + "img/coffee.dc3b85ff.svg";